import React, { useState, useEffect, useRef } from "react";
import "./OptionDashboard.css";
import * as Stomp from "stompjs";
import * as SockJS from "sockjs-client";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Box, Typography, alpha } from "@mui/material";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import BarChartIcon from "@mui/icons-material/BarChart";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import { useSelector } from "react-redux";

const OptionDashboard = () => {
  const navigate = useNavigate();
  const theme = localStorage.getItem("theme");
  const { btncolor } = useSelector((state) => state);
  const [selectedDate, setSelectedDate] = useState("All");
  const [openPreferene, setOpenPreferene] = useState(false);
  const [indexLeft, setIndexLeft] = useState(null);
  const [indexRight, setIndexRight] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [ascendingOrder, setAscendingOrder] = useState(false);

  const [isSelected, setIsSelected] = useState(false);
  const [baseCurrency, setBaseCurrency] = useState("BTCUSDT");
  const [basedate, setBasedate] = useState("All");

  const [currencyWiseFilterData, setCurrencyWiseFilterData] = useState([]);
  const [strikePlace, setStrikePlace] = useState(0);
  const [crntMarkPrice, setCrntMarkPrice] = useState(null);

  const [themeColor, setThemeColor] = useState("Dark");
  const [contractListOptions, setContractListOptions] = useState([]);
  const [selectedContractTypeId, setSelectedContractTypeId] = useState(null);
  const [pairsData, setPairsData] = useState([]);
  const [uniqueDates, setUniqueDates] = useState([]);
  const [filters, setFilters] = useState({
    positionCheck: false,
    bidAskCheck: false,
    bidPriceCheck: false,
    markPriceCheck: true,
    askPriceCheck: false,
    deltaCheck: false,
    gamaCheck: false,
    vegaCheck: false,
    thetaCheck: false,
    leverageCheck: true,
    openUsdtCheck: true,
    openContCheck: false,
    volumeCheck: true,
    lastPriceCheck: true,
    highLowCheck: true,
  });
  const [curresncyList, setCurrencyList] = useState([]);

  console.log("currencyWiseFilterData", currencyWiseFilterData);

  const preferences = [
    { id: "positionCheck", label: "Position" },
    { id: "bidAskCheck", label: "Bid/Ask Size" },
    { id: "bidPriceCheck", label: "Bid Price" },
    { id: "markPriceCheck", label: "Mark Price" },
    { id: "askPriceCheck", label: "Ask Price" },
    { id: "deltaCheck", label: "Delta" },
    { id: "gamaCheck", label: "Gamma" },
    { id: "vegaCheck", label: "Vega" },
    { id: "thetaCheck", label: "Theta" },
    { id: "leverageCheck", label: "Leverage" },
    { id: "openUsdtCheck", label: "Open (USDT)" },
    { id: "openContCheck", label: "Open (Cont)" },
    { id: "volumeCheck", label: "Volume" },
    { id: "lastPriceCheck", label: "Last Price" },
    { id: "highLowCheck", label: "High / Low" },
  ];
  const prefIds = [
    "markPriceCheck",
    "leverageCheck",
    "openUsdtCheck",
    "volumeCheck",
    "lastPriceCheck",
    "highLowCheck",
  ];
  const [checkedState, setCheckedState] = useState(
    Object.fromEntries(
      preferences.map((pref) => [
        pref.id,
        prefIds.includes(pref.id) ? true : false,
      ])
    )
  );

  const handleChange = (id) => {
    setCheckedState((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const websocketRef = useRef(null);

  const webSocketEndPoint =
    "https://options-socket.paybito.com/oSocketStream/ws";
  const topic = "/topic/optionsChain";
  const topicForBtcUsd = "/topic/stream/BTCUSD";

  let stompClient = null;
  const connectWebSocket = () => {
    console.log("connect");
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      const ws = new SockJS(webSocketEndPoint);
      stompClient = Stomp.over(ws);

      stompClient.connect(
        {},
        (frame) => {
          let topicToSubscribe = "";
          websocketRef.current.socket = stompClient;

          console.log("connection successfull", websocketRef);

          stompClient.subscribe(topic, (sdkEvent) => {
            const message = JSON.parse(sdkEvent.body);

            // Call the subscribeMessage function if defined
            if (websocketRef.current.subscribeMessage) {
              websocketRef.current.subscribeMessage(message);
            }
            onMessageReceived(sdkEvent);
          });
        },
        errorCallback
      );
    }
  };

  const errorCallback = (error) => {
    console.error("WebSocket Error:", error);
    if (localStorage.getItem("access_token")) {
      setTimeout(() => {
        connectWebSocket();
      }, 5000);
    }
  };

  const sendMessage = (message) => {
    if (stompClient) {
      stompClient.send("/app/sendRequest", {}, JSON.stringify(message));
    }
  };

  const onMessageReceived = (message) => {
    const parsedMessage = JSON.parse(message.body);
    setPairsData(parsedMessage);
    // filterDataCurrencyWise(baseCurrency);
    changeMessage(parsedMessage);
  };

  const changeMessage = (obj) => {
    console.log("Received Message:", obj);
  };

  const disconnectWebSocket = () => {
    if (stompClient && stompClient.connected) {
      console.log("Disconnecting WebSocket...");
      stompClient.disconnect(() => {
        console.log("WebSocket Disconnected");
        websocketRef.current.socket = null; // Reset WebSocket reference
      });
    } else {
      console.warn("WebSocket is not connected, skipping disconnect.");
    }
  };

  useEffect(() => {
    if (pairsData.length !== 0) {
      filterDataCurrencyWise(baseCurrency);
    }
  }, [pairsData]);

  useEffect(() => {
    const storedTheme = localStorage.getItem("themecolor");
    setThemeColor(storedTheme || "Dark");

    getContractDetailsForOptions();
    filterDataCurrencyWise(baseCurrency);

    return () => {
      if (websocketRef.current) {
        disconnectWebSocket(); // Disconnect WebSocket when the component unmounts
      }
    };
  }, [baseCurrency]);

  const getContractDetailsForOptions = async () => {
    try {
      const response = await axios.get(
        `https://accounts.paybito.com/api/optionsTrade/getContractsName`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data.statusCode === 0) {
        console.log("response-->", response);
        setContractListOptions(response.data.contractList);
        setSelectedContractTypeId(response.data.contractList[0].contractTypeId);
        websocketRef.current = {
          socket: null,
          subscribeMessage: null,
        };

        connectWebSocket();
      }
    } catch (error) {
      console.error("Error fetching contract details", error);
    }
  };

  const filterDataCurrencyWise = (currency) => {
    setIsLoading(true);
    let filteredData = pairsData.filter((x) => x.currency === currency);
    let curresncyList = pairsData
      .map((item) => item.currency)
      .filter((value, index, self) => self.indexOf(value) === index);
    setCurrencyList(curresncyList);
    console.log("filteredData", filteredData);
    setCurrencyWiseFilterData(filteredData);
    setUniqueDates([
      ...new Set(filteredData.map((item) => item.assetDateRangeCall)),
    ]);
    filterDateWiseCurrencyData();
  };

  const filterDateWiseCurrencyData = () => {
    let filteredData = [];

    if (basedate === "All") {
      filteredData = pairsData.filter((x) => x.currency === baseCurrency);
    } else {
      filteredData = pairsData.filter(
        (x) => x.assetDateRangeCall === basedate && x.currency === baseCurrency
      );
    }

    setCurrencyWiseFilterData(filteredData);
    console.log("calling isloading", isLoading);
    setIsLoading(false);

    try {
      for (let j = 0; j < filteredData.length; j++) {
        if (filteredData[j].putFlag !== filteredData[j + 1]?.putFlag) {
          console.log("found", j);
          setStrikePlace(j + 1);
          break;
        }
      }
    } catch {
      setStrikePlace(0);
    }

    if (filteredData.length > 0) {
      setCrntMarkPrice(filteredData[0].marketPriceCall);
    }

    if (isSelected) {
      const classData = localStorage.getItem("classData");
      const sideData = localStorage.getItem("sideData");
      // setTimeout(() => selectRow(classData, sideData), 300);
    }
  };

  const sortDataByStrike = () => {
    setIsLoading(true);

    const sorted = [...currencyWiseFilterData].sort((a, b) => {
      if (!ascendingOrder) {
        return a.strikeCall - b.strikeCall; // ascending
      } else {
        return b.strikeCall - a.strikeCall; // descending
      }
    });

    setCurrencyWiseFilterData(sorted);
    // optional: if you want to toggle order each time
    setAscendingOrder((prev) => !prev);
    setIsLoading(false);
  };

  const getCurrencyWiseList = (e) => {
    setBaseCurrency(e);
    setBasedate("All");
    filterDataCurrencyWise(e);
    localStorage.setItem("buying_crypto_asset_options", getCurrencyCode(e));
  };

  const getCurrencyLogo = (currency) => {
    const logos = {
      ETHUSDT:
        "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/ETH.png",
      DOGEUSDT:
        "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/DOGE.png",
      BTCUSDT:
        "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/BTC.png",
      XRPUSDT:
        "https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/XRP.png",
    };
    return logos[currency] || null;
  };
  const getCurrencyCode = (currency) => {
    const curcode = {
      ETHUSDT: "ETH",
      DOGEUSDT: "DOGE",
      BTCUSDT: "BTC",
      XRPUSDT: "XRP",
    };
    return curcode[currency] || null;
  };

  console.log("currencyWiseFilterData", currencyWiseFilterData);

  return (
    <Box sx={pageWrapper}>

      {/* ── Ticker Strip ── */}
      <Box sx={tickerStrip}>

        {/* Left — Pair badge */}
        <Box sx={tickerPairBadge}>
          <Box sx={tickerPairIconWrap}>
            <ShowChartOutlinedIcon sx={{ fontSize: 15, color: "#fff" }} />
          </Box>
          <Box>
            <Typography sx={tickerPairText}>{baseCurrency}</Typography>
            <Typography sx={tickerPairSub}>Options</Typography>
          </Box>
        </Box>

        {/* Center — Currency tabs + stats */}
        <Box sx={tickerStatsCenter}>
          <Box sx={tickerDivider} />

          {/* Currency selection tabs */}
          {curresncyList?.map((d, i) => (
            <Box
              key={i}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: "5px",
                px: "11px",
                py: "4px",
                borderRadius: "8px",
                border: "1px solid",
                fontSize: "0.72rem",
                cursor: "pointer",
                userSelect: "none",
                transition: "all 0.15s ease",
                letterSpacing: "0.01em",
                mx: "3px",
                backgroundColor: baseCurrency === d
                  ? alpha(btncolor || "#1976d2", 0.15)
                  : "transparent",
                borderColor: baseCurrency === d
                  ? alpha(btncolor || "#1976d2", 0.4)
                  : "rgba(125,125,125,0.2)",
                color: baseCurrency === d
                  ? btncolor || "#1976d2"
                  : "var(--text-color)",
                fontWeight: baseCurrency === d ? 700 : 500,
              }}
              onClick={() => getCurrencyWiseList(d)}
            >
              {getCurrencyLogo(d) && (
                <img
                  src={getCurrencyLogo(d)}
                  style={{ width: 14, height: 14, borderRadius: "50%" }}
                  alt={d}
                />
              )}
              {d}
            </Box>
          ))}

          <Box sx={tickerDivider} />

          {/* Mark Price */}
          <Box sx={tickerStat}>
            <Typography sx={tickerStatLabel}>MARK PRICE</Typography>
            <Typography sx={{ ...tickerStatValue, color: "#21CB80", fontWeight: 800 }}>
              {crntMarkPrice || "—"}
            </Typography>
          </Box>

          <Box sx={tickerDivider} />

          {/* Selected */}
          <Box sx={tickerStat}>
            <Typography sx={tickerStatLabel}>SELECTED</Typography>
            <Typography sx={tickerStatValue}>
              {selectedDate}{selectedDate === "All" ? " Contracts" : ""}
            </Typography>
          </Box>

          <Box sx={tickerDivider} />
        </Box>

        {/* Right — Status */}
        <Box sx={tickerConnectionWrap}>
          <Box sx={tickerConnectionPill}>
            <Box
              sx={{
                width: 6, height: 6, borderRadius: "50%", flexShrink: 0,
                backgroundColor: isLoading ? "#F5BD47" : "#21CB80",
                boxShadow: isLoading ? "0 0 5px #F5BD47" : "0 0 5px #21CB80",
                animation: !isLoading ? "tickerPulse 2s ease-in-out infinite" : "none",
              }}
            />
            <Typography sx={{ fontSize: "0.7rem", fontWeight: 700, color: isLoading ? "#F5BD47" : "#21CB80", letterSpacing: "0.06em" }}>
              {isLoading ? "LOADING" : "LIVE"}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ── Main Layout ── */}
      <Box sx={tradingLayout}>

        {/* Date filter + Preferences toolbar */}
        <Box sx={{ ...panelCard, mb: "6px", overflow: "visible" }}>
          <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", px: "12px", py: "8px" }}>

            {/* Date tabs */}
            <Box sx={{ display: "flex", alignItems: "center", gap: "4px", flexWrap: "wrap" }}>
              <Box
                sx={{
                  ...dateTabBtn,
                  backgroundColor: selectedDate === "All"
                    ? alpha(btncolor || "#1976d2", 0.15)
                    : "transparent",
                  borderColor: selectedDate === "All"
                    ? alpha(btncolor || "#1976d2", 0.4)
                    : "rgba(125,125,125,0.2)",
                  color: selectedDate === "All"
                    ? btncolor || "#1976d2"
                    : "var(--text-color)",
                  fontWeight: selectedDate === "All" ? 700 : 500,
                }}
                onClick={() => { setSelectedDate("All"); setIsLoading(true); }}
              >
                All
              </Box>
              {uniqueDates?.map((d, i) => (
                <Box
                  key={i}
                  sx={{
                    ...dateTabBtn,
                    backgroundColor: selectedDate === d
                      ? alpha(btncolor || "#1976d2", 0.15)
                      : "transparent",
                    borderColor: selectedDate === d
                      ? alpha(btncolor || "#1976d2", 0.4)
                      : "rgba(125,125,125,0.2)",
                    color: selectedDate === d
                      ? btncolor || "#1976d2"
                      : "var(--text-color)",
                    fontWeight: selectedDate === d ? 700 : 500,
                  }}
                  onClick={() => { setSelectedDate(d); setIsLoading(true); }}
                >
                  {d}
                </Box>
              ))}
            </Box>

            {/* Preferences button */}
            <Box sx={{ position: "relative", ml: "auto" }}>
              <Box
                sx={{
                  display: "inline-flex", alignItems: "center", gap: "5px",
                  px: "12px", py: "5px", borderRadius: "8px",
                  border: "1px solid rgba(125,125,125,0.2)",
                  cursor: "pointer", fontSize: "0.75rem",
                  color: "var(--text-color)", userSelect: "none",
                  transition: "all 0.15s ease",
                  backgroundColor: openPreferene ? "rgba(125,125,125,0.1)" : "transparent",
                }}
                onClick={() => setOpenPreferene(!openPreferene)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  style={{ height: 14, color: "gray" }}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 6h-7.79a4.001 4.001 0 00-7.42 0H3v3h2.79a4.001 4.001 0 007.42 0H21V6zm-10.21 9H3v3h7.79a4.001 4.001 0 007.42 0H21v-3h-2.79a4.001 4.001 0 00-7.42 0z"
                    fill="currentColor"
                  />
                </svg>
                Preferences
              </Box>

              {openPreferene && (
                <Box sx={preferencesDropdown}>
                  <Typography sx={{
                    fontSize: "11px", fontWeight: 700,
                    px: "10px", py: "7px",
                    borderBottom: "1px solid rgba(125,125,125,0.13)",
                    color: "var(--text-color)",
                  }}>
                    Preferences
                  </Typography>
                  <Box sx={{ display: "flex", flexDirection: "column", py: "4px" }}>
                    {preferences.map((pref) => (
                      <Box
                        key={pref.id}
                        sx={{
                          display: "flex", alignItems: "center", gap: "7px",
                          px: "10px", py: "4px", cursor: "pointer",
                          "&:hover": { backgroundColor: "rgba(125,125,125,0.07)" },
                        }}
                        onClick={() => handleChange(pref.id)}
                      >
                        <input
                          type="checkbox"
                          id={pref.id}
                          checked={checkedState[pref.id]}
                          onChange={() => handleChange(pref.id)}
                          style={{ cursor: "pointer" }}
                        />
                        <label
                          htmlFor={pref.id}
                          style={{ fontSize: "11px", cursor: "pointer", color: "var(--text-color)", margin: 0 }}
                        >
                          {pref.label}
                        </label>
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>

        {/* Loading indicator */}
        {isLoading && (
          <Box sx={{ display: "flex", justifyContent: "center", py: "24px" }}>
            <div className="loading style-2">
              <div className="loading-wheel"></div>
            </div>
          </Box>
        )}

        {/* ── Main Options Chain Table ── */}
        <Box sx={panelCard}>

          {/* Calls / Price / Puts header */}
          <Box sx={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            px: "16px", py: "10px",
            borderBottom: "1px solid rgba(125,125,125,0.13)",
            backgroundColor: "var(--body-color-less2)",
          }}>
            <Typography sx={{ fontSize: "0.75rem", fontWeight: 700, width: "45%", textAlign: "center", color: "#21CB80", letterSpacing: "0.06em" }}>
              CALLS
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: "10%" }}>
              <Typography sx={{ fontSize: "0.6rem", fontWeight: 700, opacity: 0.5, letterSpacing: "0.05em", textTransform: "uppercase" }}>
                Mark Price
              </Typography>
              <Typography sx={{ fontSize: "0.85rem", fontWeight: 800, color: "#21CB80" }}>
                {crntMarkPrice || "—"}
              </Typography>
              <Typography sx={{ fontSize: "0.6rem", fontWeight: 600, opacity: 0.45 }}>
                {selectedDate}{selectedDate === "All" ? " Contracts" : ""}
              </Typography>
            </Box>
            <Typography sx={{ fontSize: "0.75rem", fontWeight: 700, width: "45%", textAlign: "center", color: "#F5475D", letterSpacing: "0.06em" }}>
              PUTS
            </Typography>
          </Box>

          {/* Responsive small-screen header (Calls) */}
          <div className="callputstricksmallscreen">
            <p className="text-center">Calls</p>
          </div>

          {/* Tables row */}
          <div className="callputstrick">
            {/* Calls table */}
            <div
              style={{
                overflowX: "auto",
                whiteSpace: "nowrap",
                scrollbarColor: "var(--body-color-less2)",
                padding: "0 20px",
              }}
              className="callright"
            >
              <table
                className="option_left_table"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead>
                  <tr>
                    <th className="text-center p-2" />
                    {checkedState?.highLowCheck && (
                      <th className="text-center p-2">Highs/lows</th>
                    )}
                    {<th className="text-center p-2">Contract</th>}
                    {checkedState?.lastPriceCheck && (
                      <th className="text-center p-2">Last Price</th>
                    )}
                    {checkedState?.volumeCheck && (
                      <th className="text-center p-2">Volume</th>
                    )}
                    {checkedState?.leverageCheck && (
                      <th className="text-center p-2">Leverage</th>
                    )}
                    {checkedState?.openContCheck && (
                      <th className="text-center p-2">Open (Cont)</th>
                    )}
                    {checkedState?.thetaCheck && (
                      <th className="text-center p-2">Theta</th>
                    )}
                    {checkedState?.vegaCheck && (
                      <th className="text-center p-2">Vega</th>
                    )}
                    {checkedState?.gamaCheck && (
                      <th className="text-center p-2">Gamma</th>
                    )}
                    {checkedState?.deltaCheck && (
                      <th className="text-center p-2">Delta</th>
                    )}
                    {checkedState?.openUsdtCheck && (
                      <th className="text-center p-2">Open (USDT)</th>
                    )}
                    {checkedState?.bidAskCheck && (
                      <th className="text-center p-2">Bid Size</th>
                    )}
                    {checkedState?.bidPriceCheck && (
                      <th className="text-center p-2">Bid/IV</th>
                    )}
                    {checkedState?.markPriceCheck && (
                      <th className="text-center p-2">Mark/IV</th>
                    )}
                    {checkedState?.askPriceCheck && (
                      <th className="text-center p-2">Ask/IV</th>
                    )}
                    {checkedState?.positionCheck && (
                      <th className="text-center p-2">Position</th>
                    )}
                    {checkedState?.bidAskCheck && (
                      <th className="text-center p-2">Ask Size</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {currencyWiseFilterData?.map((data, i) => (
                    <tr
                      key={i}
                      className={data?.putFlag == "HIGH" ? "tableHeaderLow" : ""}
                      style={{
                        transition: "border 0.3s ease-in-out",
                        margin: "10px 0",
                        position: "relative",
                        display: "table-row",
                      }}
                      onMouseEnter={(e) => (
                        (e.currentTarget.style.border = "1px solid aqua"),
                        setIndexLeft(i)
                      )}
                      onMouseLeave={(e) => (
                        (e.currentTarget.style.border = "none"), setIndexLeft(null)
                      )}
                    >
                      <td>
                        <div className="text-center" style={{ width: "20px" }}>
                          {indexLeft === i ? (
                            <BarChartIcon
                              style={{ fontSize: "15px", cursor: "pointer" }}
                              onClick={() => {
                                localStorage.setItem("selected_options_asset_pair", data?.assetPairCall);
                                localStorage.setItem("selected_options_asset_pair_name", data?.assetPairCall);
                                navigate("/options", { state: data?.assetPairCall });
                              }}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                      {checkedState?.highLowCheck && (
                        <td className="d-flex text-center p-3 flex items-center justify-center">
                          <span>{data.highPriceCall}</span>
                        </td>
                      )}
                      <td className="text-center p-3">
                        {data?.assetDateRangeCall}
                      </td>
                      {checkedState?.lastPriceCheck && (
                        <td className="text-center p-3">{data?.marketPriceCall}</td>
                      )}
                      {checkedState?.volumeCheck && (
                        <td className="text-center p-3">{data?.volumeCall}</td>
                      )}
                      {checkedState?.leverageCheck && (
                        <td className="text-center p-3">{data?.callLeverage}</td>
                      )}
                      {checkedState?.openContCheck && (
                        <td className="text-center p-3">---</td>
                      )}
                      {checkedState?.thetaCheck && (
                        <td className="text-center p-3">{data?.thetaCall}</td>
                      )}
                      {checkedState?.vegaCheck && (
                        <td className="text-center p-3">{data?.vegaCall}</td>
                      )}
                      {checkedState?.gamaCheck && (
                        <td className="text-center p-3">{data?.gammaCall}</td>
                      )}
                      {checkedState?.deltaCheck && (
                        <td className="text-center p-3">{data?.deltaCall}</td>
                      )}
                      {checkedState?.openUsdtCheck && (
                        <td className="text-center p-3">{data?.openCall}</td>
                      )}
                      {checkedState?.bidAskCheck && (
                        <td className="text-center p-3">{data?.bidCall}</td>
                      )}
                      {checkedState?.bidPriceCheck && (
                        <td className="text-center p-3">-</td>
                      )}
                      {checkedState?.markPriceCheck && (
                        <td className="text-center p-3">{data?.markCall}</td>
                      )}
                      {checkedState?.askPriceCheck && (
                        <td className="text-center p-3">{data?.askCall}</td>
                      )}
                      {checkedState?.positionCheck && (
                        <td className="text-center p-3">{data?.positionCall}</td>
                      )}
                      {checkedState?.bidAskCheck && (
                        <td className="text-center p-3">{data?.askCall}</td>
                      )}
                      <div
                        style={{
                          position: "absolute",
                          zIndex: "9999",
                          left: "0",
                          width: "100%",
                        }}
                      >
                        {i === strikePlace && <div className="verticleLine" />}
                      </div>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Responsive small-screen price header */}
            <div className="callputstricksmallscreen">
              <div
                style={{ background: "var(--body-color-less2)" }}
                className="d-flex justify-content-center align-items-center"
              >
                <p className="px-2">
                  {baseCurrency} Price:{" "}
                  <span className="text-success">{crntMarkPrice}</span>
                </p>
                <p style={{ fontSize: "20px" }}>
                  {selectedDate} {selectedDate === "All" && "Contracts"}
                </p>
              </div>
            </div>

            {/* Strike column */}
            <div
              style={{
                overflowX: "auto",
                whiteSpace: "nowrap",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                backgroundColor: "var(--body-color-less2)",
                margin: "0px 0 0 25px",
              }}
              className="strickmiddle"
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  textAlign: "center",
                }}
              >
                <thead>
                  <tr>
                    <td
                      className="text-center p-2 d-flex justify-content-center"
                      style={{ backgroundColor: "var(--body-color-less2)" }}
                    >
                      Strikes
                      <div
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                        onClick={() => sortDataByStrike()}
                      >
                        <SwapVertIcon />
                      </div>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {currencyWiseFilterData?.map((d, i) => (
                    <tr key={i} className="position-relative d-flex flex-column">
                      {i === strikePlace - 1 && (
                        <div className="smallPrice">
                          <span
                            style={{
                              backgroundColor: "yellow",
                              padding: "5px",
                              borderRadius: "10px",
                            }}
                          >
                            {crntMarkPrice}
                          </span>
                        </div>
                      )}
                      <td className="text-center p-3">{d?.strikeCall}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Responsive small-screen puts header */}
            <div className="callputstricksmallscreen">
              <p className="text-center">Puts</p>
            </div>

            {/* Puts table */}
            <div
              style={{
                overflowX: "auto",
                whiteSpace: "nowrap",
                scrollbarColor: "var(--body-color-less2)",
                padding: "0 20px",
              }}
              className="putLeft"
            >
              <table
                className="option_right_table"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead>
                  <tr>
                    <th className="text-center p-2" />
                    {checkedState?.highLowCheck && (
                      <th className="text-center p-2">Highs/lows</th>
                    )}
                    {checkedState?.lastPriceCheck && (
                      <th className="text-center p-2">Last Price</th>
                    )}
                    {checkedState?.volumeCheck && (
                      <th className="text-center p-2">Volume</th>
                    )}
                    {checkedState?.leverageCheck && (
                      <th className="text-center p-2">Leverage</th>
                    )}
                    {checkedState?.openContCheck && (
                      <th className="text-center p-2">Open (Cont)</th>
                    )}
                    {checkedState?.thetaCheck && (
                      <th className="text-center p-2">Theta</th>
                    )}
                    {checkedState?.vegaCheck && (
                      <th className="text-center p-2">Vega</th>
                    )}
                    {checkedState?.gamaCheck && (
                      <th className="text-center p-2">Gamma</th>
                    )}
                    {checkedState?.deltaCheck && (
                      <th className="text-center p-2">Delta</th>
                    )}
                    {checkedState?.openUsdtCheck && (
                      <th className="text-center p-2">Open (USDT)</th>
                    )}
                    {checkedState?.bidAskCheck && (
                      <th className="text-center p-2">Bid Size</th>
                    )}
                    {checkedState?.bidPriceCheck && (
                      <th className="text-center p-2">Bid/IV</th>
                    )}
                    {checkedState?.markPriceCheck && (
                      <th className="text-center p-2">Mark/IV</th>
                    )}
                    {checkedState?.askPriceCheck && (
                      <th className="text-center p-2">Ask/IV</th>
                    )}
                    {checkedState?.positionCheck && (
                      <th className="text-center p-2">Position</th>
                    )}
                    {checkedState?.bidAskCheck && (
                      <th className="text-center p-2">Ask Size</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {currencyWiseFilterData?.map((data, i) => (
                    <tr
                      key={i}
                      className={data?.putFlag !== "HIGH" ? "tableHeaderLow" : ""}
                      style={{
                        transition: "border 0.3s ease-in-out",
                        margin: "10px 0",
                        position: "relative",
                      }}
                      onMouseEnter={(e) => (
                        (e.currentTarget.style.border = "1px solid aqua"),
                        setIndexRight(i)
                      )}
                      onMouseLeave={(e) => (
                        (e.currentTarget.style.border = "none"), setIndexRight(null)
                      )}
                    >
                      <td>
                        <div className="text-center" style={{ width: "20px" }}>
                          {indexRight === i ? (
                            <BarChartIcon
                              style={{ fontSize: "15px", cursor: "pointer" }}
                              onClick={() => {
                                localStorage.setItem("selected_options_asset_pair", data?.assetPairPut);
                                localStorage.setItem("selected_options_asset_pair_name", data?.assetPairPut);
                                navigate("/options", { state: data?.assetPairPut });
                              }}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                      {checkedState?.highLowCheck && (
                        <td className="d-flex text-center p-3 flex items-center justify-center">
                          <span>{data.highPricePut}</span>
                        </td>
                      )}
                      {checkedState?.lastPriceCheck && (
                        <td className="text-center p-3">{data?.marketPricePut}</td>
                      )}
                      {checkedState?.volumeCheck && (
                        <td className="text-center p-3">{data?.volumePut}</td>
                      )}
                      {checkedState?.leverageCheck && (
                        <td className="text-center p-3">{data?.putLeverage}</td>
                      )}
                      {checkedState?.openContCheck && (
                        <td className="text-center p-3">---</td>
                      )}
                      {checkedState?.thetaCheck && (
                        <td className="text-center p-3">{data?.thetaPut}</td>
                      )}
                      {checkedState?.vegaCheck && (
                        <td className="text-center p-3">{data?.vegaPut}</td>
                      )}
                      {checkedState?.gamaCheck && (
                        <td className="text-center p-3">{data?.gammaPut}</td>
                      )}
                      {checkedState?.deltaCheck && (
                        <td className="text-center p-3">{data?.deltaPut}</td>
                      )}
                      {checkedState?.openUsdtCheck && (
                        <td className="text-center p-3">{data?.openPut}</td>
                      )}
                      {checkedState?.bidAskCheck && (
                        <td className="text-center p-3">{data?.bidPut}</td>
                      )}
                      {checkedState?.bidPriceCheck && (
                        <td className="text-center p-3">-</td>
                      )}
                      {checkedState?.markPriceCheck && (
                        <td className="text-center p-3">{data?.markPut}</td>
                      )}
                      {checkedState?.askPriceCheck && (
                        <td className="text-center p-3">{data?.askPut}</td>
                      )}
                      {checkedState?.positionCheck && (
                        <td className="text-center p-3">{data?.positionPut}</td>
                      )}
                      {checkedState?.bidAskCheck && (
                        <td className="text-center p-3">{data?.askPut}</td>
                      )}
                      <div
                        style={{
                          position: "absolute",
                          zIndex: "9999",
                          left: "0",
                          width: "100%",
                        }}
                      >
                        {i === strikePlace && <div className="verticleLine" />}
                      </div>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Box>

      </Box>
    </Box>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────

const pageWrapper = {
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "100vh",
  zoom: "90%",
};

// Ticker strip
const tickerStrip = {
  display: "flex",
  alignItems: "center",
  flexWrap: "nowrap",
  px: { xs: 2, md: "14px" },
  py: "10px",
  mb: "6px",
  backgroundColor: "var(--body-color-less)",
  borderBottom: "1px solid rgba(125,125,125,0.18)",
  position: "relative",
};

// Center stats group — takes remaining space, centers content
const tickerStatsCenter = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 0,
  overflow: "hidden",
  flexWrap: "wrap",
};

const tickerPairBadge = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  pr: { md: "20px" },
  mr: { md: "4px" },
};

const tickerPairIconWrap = {
  width: 32,
  height: 32,
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(125,125,125,0.18)",
  flexShrink: 0,
};

const tickerPairText = {
  fontSize: { xs: "0.95rem", md: "1rem" },
  fontWeight: 800,
  color: "var(--text-color)",
  letterSpacing: "0.02em",
  lineHeight: 1.2,
};

const tickerPairSub = {
  fontSize: "0.6rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.4,
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  lineHeight: 1,
  mt: "2px",
};

const tickerDivider = {
  width: "1px",
  height: 30,
  backgroundColor: "rgba(125,125,125,0.2)",
  mx: { xs: 0, md: "16px" },
  display: { xs: "none", md: "block" },
  flexShrink: 0,
};

const tickerStat = {
  display: "flex",
  flexDirection: "column",
  gap: "3px",
  pr: { md: "16px" },
};

const tickerStatLabel = {
  fontSize: "0.58rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.45,
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  lineHeight: 1,
};

const tickerStatValue = {
  fontSize: "0.82rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
  display: "flex",
  alignItems: "center",
};

const tickerConnectionWrap = {
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
};

const tickerConnectionPill = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  px: "10px",
  py: "4px",
  borderRadius: "20px",
  border: "1px solid rgba(125,125,125,0.2)",
  backgroundColor: "rgba(125,125,125,0.08)",
};

// Trading layout
const tradingLayout = {
  px: "6px",
  pb: "50px",
};

// Panel / card wrapper
const panelCard = {
  backgroundColor: "var(--body-color-less)",
  border: "1px solid rgba(125,125,125,0.13)",
  borderRadius: "10px",
  overflow: "hidden",
};

// Date filter tab button
const dateTabBtn = {
  display: "inline-flex",
  alignItems: "center",
  gap: "5px",
  px: "10px",
  py: "4px",
  borderRadius: "7px",
  border: "1px solid",
  fontSize: "0.72rem",
  cursor: "pointer",
  userSelect: "none",
  transition: "all 0.15s ease",
  letterSpacing: "0.01em",
};

// Preferences dropdown
const preferencesDropdown = {
  position: "absolute",
  right: 0,
  top: "110%",
  zIndex: 99,
  minWidth: 165,
  borderRadius: "10px",
  overflow: "hidden",
  boxShadow: "0 8px 24px rgba(0,0,0,0.22)",
  border: "1px solid rgba(125,125,125,0.18)",
  backgroundColor: "var(--body-color-less)",
};

export default OptionDashboard;
